import {
  DrivewayLengthType,
  DrivewayRelocationDistanceType,
  DrivewayShapeType,
  DrivewaySurfaceType,
  DrivewayWidthType,
  PropertyType,
} from '@quikplow/quikplow-types';

const propertyTypeOptions = ['commercial', 'residential'] as const;
export function isValidPropertyType(value: string): value is PropertyType {
  return propertyTypeOptions.includes(value as PropertyType);
}

const drivewaySurfaceTypeOptions = ['paved', 'dirt', 'gravel'] as const;
export function isValidDrivewaySurfaceType(value: string): value is DrivewaySurfaceType {
  return drivewaySurfaceTypeOptions.includes(value as DrivewaySurfaceType);
}

const drivewayShapeTypeOptions = ['straight', 'curvy', 'horseshoe'] as const;
export function isValidDrivewayShapeType(value: string): value is DrivewayShapeType {
  return drivewayShapeTypeOptions.includes(value as DrivewayShapeType);
}

const drivewayWidthTypeOptions = ['oneCar', 'twoCars', 'threeCars', 'fourCars', 'fiveCars', 'moreThanFiveLessThanTen', 'moreThanTenLessThanTwenty'] as const;
export function isValidDrivewayWidthType(value: string): value is DrivewayWidthType {
  return drivewayWidthTypeOptions.includes(value as DrivewayWidthType);
}

const drivewayLengthTypeOptions = ['oneCar', 'twoCars', 'threeCars', 'fourCars', 'fiveCars', 'footballField', 'twoFootballFields', 'moreThanTwoFootballFields'] as const;
export function isValidDrivewayLengthType(value: string): value is DrivewayLengthType {
  return drivewayLengthTypeOptions.includes(value as DrivewayLengthType);
}

const drivewayRelocationDistanceTypeOptions = ['inDriveway', 'close', 'moderate', 'far', 'veryFar'] as const;
export function isValidDrivewayRelocationDistanceType(value: string): value is DrivewayRelocationDistanceType {
  return drivewayRelocationDistanceTypeOptions.includes(value as DrivewayRelocationDistanceType);
}
